/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Power_SourceInputs */

const en_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power Source`)
};

const es_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente de energía`)
};

const fr_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source d'alimentation`)
};

const de_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stromquelle`)
};

const ja_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動力源`)
};

const zh_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动力源`)
};

const ar_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مصدر الطاقة`)
};

const id_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber Daya`)
};

const it_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alimentazione`)
};

const ru_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Источник питания`)
};

const pt_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte de Energia`)
};

const ko_field_power_source = /** @type {(inputs: Field_Power_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동력원`)
};

/**
* | output |
* | --- |
* | "Power Source" |
*
* @param {Field_Power_SourceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_power_source = /** @type {((inputs?: Field_Power_SourceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Power_SourceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_power_source(inputs)
	if (locale === "es") return es_field_power_source(inputs)
	if (locale === "fr") return fr_field_power_source(inputs)
	if (locale === "de") return de_field_power_source(inputs)
	if (locale === "ja") return ja_field_power_source(inputs)
	if (locale === "zh") return zh_field_power_source(inputs)
	if (locale === "ar") return ar_field_power_source(inputs)
	if (locale === "id") return id_field_power_source(inputs)
	if (locale === "it") return it_field_power_source(inputs)
	if (locale === "ru") return ru_field_power_source(inputs)
	if (locale === "pt") return pt_field_power_source(inputs)
	return ko_field_power_source(inputs)
});